import PLANS_ACTION from '../../constants/action'
import PLANS_PATH from '../../constants/path'
import { setIdReduxAction } from '../../../redux/actions/set-id'

function updateStartedPlanAction (instance) {
  return setIdReduxAction({
    type: instance
      ? PLANS_ACTION.UPDATE_STARTED
      : PLANS_ACTION.RESET_STARTED,
    payload: {
      path: PLANS_PATH.STARTED,
      instance
    }
  })
}

export default updateStartedPlanAction
